<template>
    <div>
        <div style="display: flex;">
            <router-link to="/admin/users/new">
                <el-button type="primary" size="mini">Add New</el-button>
            </router-link>
        </div>
        <el-table :data="tableData" stripe style="width: 100%">
            <el-table-column prop="id" label="ID" width="180">
            </el-table-column>
            <el-table-column prop="attributes.email" label="Email" width="180">
            </el-table-column>
            <el-table-column prop="attributes.name" label="Name" width="180">
            </el-table-column>
            <el-table-column label="Operations" width="120">
                <template slot-scope="scope">
                    <router-link :to="`/admin/users/${scope.row.id}`">
                        <el-button type="text" size="small">Edit</el-button>
                    </router-link>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
import axios from 'axios'
export default {
    data() {
        return {
            tableData: [
                { email: '' }
            ]
        }
    },
    mounted() {
        this.$store.dispatch('users/loadAll').then(() => {
            const users = this.$store.getters['users/all'];
            this.tableData = users;
        });
    },
    methods: {

    }
}
</script>